import { useCurrentUser } from '~/src/common/user/useCurrentUser';
import { useHasMounted } from '~/src/components/hooks/useHasMounted';
import { useIsSSR } from '~/src/components/hooks/useIsSSR';

import { getGlobalSearchButtonVisibility } from './getGlobalSearchButtonVisibility';

export function useHeaderGlobalSearchButtonVisibility() {
  const { isLoggedIn, loading } = useCurrentUser();

  const isSSR = useIsSSR();
  const { hasMounted } = useHasMounted();
  const pathname = isSSR ? '' : location?.pathname;

  return getGlobalSearchButtonVisibility({
    isLoggedIn,
    isSSR: !hasMounted,
    isUserDetailsLoading: loading,
    pathname: pathname ?? '',
  });
}
